import React, { useCallback, useEffect, useState } from 'react';
import { Error, Loading, useGetList, useDataProvider } from 'react-admin';
import ContactsList from './ContactsList';
import { TextField } from '@material-ui/core';
import { useProfile } from '../../../../core/hooks/UseProfile';
import useNotifyServerError from '../../../../core/hooks/useNotifyServerError';
import { useStyles } from '../../../users/userauthorization/stepper/styles';
import {
  createUserAuthorizations,
  setSearch
} from '../../../users/userauthorization/stepper/utils';
import { useGetAuthorizations } from '../../copyContactsSteps/ContactsStep';

const AddRelatedContactsStep = ({
  currentAuthorizations,
  contacts,
  setContacts,
  permissionGroupsUploaded,
  relatedFundsUploaded,
  setContactAuthorizationsIds,
  contactAuthorizationsIds,
  setIsNextAvailable,
  authorizationsGridToDeleteRef,
  setCurrentAuthorizations,
  onSubmitEnd,
  hasAssignUserAuthorization,
  setPermissionGroupsUploaded,
  ...props
}) => {
  const [filteredContacts, setFilteredContacts] = useState([]);
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { profile: connectedUserProfile } = useProfile();
  const notifyServerError = useNotifyServerError();
  const dataProvider = useDataProvider();

  const { data: rcData, error: rcError, loading: rcLoading } = useGetList(
    'users',
    {},
    { field: 'fullName', order: 'ASC' },
    { userType: 'REGULAR_CONTACT' }
  );
  const { data: iaData, error: iaError, loading: iaLoading } = useGetList(
    'users',
    {},
    { field: 'fullName', order: 'ASC' },
    { userType: 'INVESTOR_ADMIN' }
  );

  const [groups, setGroups] = useState();
  const [groupsLoading, setGroupsLoading] = useState(true);
  const [groupsError, setGroupsError] = useState();
  useEffect(() => {
    dataProvider
      .getList('groups', {
        pagination: { page: 1, perPage: -1 },
        sort: { field: 'name', order: 'ASC' },
        filter: { adminGroup: false, status: 'ACTIVE' }
      })
      .then(res => {
        setGroups(res.data);
        setGroupsLoading(false);
      })
      .catch(err => {
        setGroupsError(err);
        notifyServerError(err, null);
      });
  }, [dataProvider, notifyServerError]);

  const { data: connectedUserAuthorizations } = useGetAuthorizations(
    connectedUserProfile
  );

  useEffect(() => {
    const allContactsSorted = [
      ...Object.values(rcData),
      ...Object.values(iaData)
    ].sort((a, b) =>
      a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
    );
    setContacts(allContactsSorted);
    setFilteredContacts(allContactsSorted);
    setError(iaError || rcError || groupsError);
    setLoading(iaLoading || rcLoading || groupsLoading);
  }, [
    groupsError,
    groupsLoading,
    iaData,
    iaError,
    iaLoading,
    rcData,
    rcError,
    rcLoading,
    setContacts
  ]);

  const handleSearchChange = useCallback(
    e => {
      setSearch(setFilteredContacts, contacts, e);
    },
    [contacts]
  );

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error />;
  }

  return (
    <>
      <TextField
        margin="dense"
        placeholder={`Search...`}
        onChange={handleSearchChange}
      />
      <ContactsList
        contacts={filteredContacts}
        classes={classes}
        currentAuthorizations={currentAuthorizations}
        groups={Object.values(groups)}
        permissionGroupsUploaded={permissionGroupsUploaded}
        relatedFundsUploaded={relatedFundsUploaded}
        setContactAuthorizationsIds={setContactAuthorizationsIds}
        contactAuthorizationsIds={contactAuthorizationsIds}
        connectedUserProfile={connectedUserProfile}
        setIsNextAvailable={setIsNextAvailable}
        authorizationsGridToDeleteRef={authorizationsGridToDeleteRef}
        setCurrentAuthorizations={setCurrentAuthorizations}
        onSubmitEnd={onSubmitEnd}
        hasAssignUserAuthorization={hasAssignUserAuthorization}
        authorizationsConnectedUser={createUserAuthorizations(
          connectedUserAuthorizations
        )}
        setPermissionGroupsUploaded={setPermissionGroupsUploaded}
        {...props}
      />
    </>
  );
};

export default AddRelatedContactsStep;
